import apiFetch from '@wordpress/api-fetch';

import { type ImageSizesKey, type WPImageType } from '@/src/Types/Shared/Image';

export const fetchImage = async (
	id: number | string,
	size: ImageSizesKey
): Promise<{ url?: string; alt?: string }> => {
	if (!id)
		return {
			url: undefined,
			alt: undefined,
		};

	try {
		const image: WPImageType = await apiFetch({
			path: '/wp/v2/media/' + id,
		});
		if (image) {
			if (image.media_details?.sizes[size]) {
				return {
					url: image.media_details?.sizes[size].source_url,
					alt: image.alt_text,
				};
			} else {
				return {
					url: image.source_url,
					alt: image.alt_text,
				};
			}
		}
	} catch (e) {
		// skip error
	}
	return {
		url: undefined,
		alt: undefined,
	};
};

export const fetchImageWithId = async (
	id: number | string,
	size: ImageSizesKey
): Promise<{ url?: string; alt?: string; id?: number | string }> => {
	if (!id)
		return {
			url: undefined,
			alt: undefined,
			id: id,
		};

	try {
		const image: WPImageType = await apiFetch({
			path: '/wp/v2/media/' + id,
		});
		if (image) {
			if (image.media_details?.sizes[size]) {
				return {
					url: image.media_details?.sizes[size].source_url,
					alt: image.alt_text,
					id: id,
				};
			} else {
				return {
					url: image.source_url,
					alt: image.alt_text,
					id: id,
				};
			}
		}
	} catch (e) {
		// skip error
	}
	return {
		url: undefined,
		alt: undefined,
		id: id,
	};
};

export const getImage = (setValue: any, imageID: number, size: ImageSizesKey) => {
	if (!imageID)
		return {
			url: undefined,
			alt: undefined,
		};

	const media: Promise<WPImageType> = apiFetch({
		path: '/wp/v2/media/' + imageID,
	});
	media.then((img: WPImageType) => {
		if (Object.prototype.hasOwnProperty.call(img.media_details?.sizes, size)) {
			setValue({
				url: img.media_details?.sizes[size].source_url,
				alt: img.alt_text,
			});
		} else {
			setValue({
				url: img.source_url,
				alt: img.alt_text,
			});
		}
	});
};
